/** 기본 제공 점검표 법령명 */
export const LEG_BASIC_DEFAULT_LAW_NM = '산업안전보건법';

/** 점검표 추가 시 고정 옵션 (신규법령 추가) */
export const LEG_BASIC_LAW_SELECT_NEW_OPTION = {
  id: 'NEW',
  name: '신규법령 추가',
  description:
    '전기안전관리법, 위험물관리법, 소방시설법 등 사업장 자체 점검표를 만듭니다.',
};

/**
 * 서버 법령 목록 + 신규법령 추가로 선택 옵션 구성
 * @param {Array<{lawNm?: string, LawNm?: string, defaultYn?: string, DefaultYn?: string}>} lawRows
 */
export const BuildLegBasicLawSelectOptions = (lawRows = []) => {
  const seen = new Set();
  const options = [];

  const PushLaw = (lawNm, isDefault = false) => {
    const name = String(lawNm ?? '').trim();
    if (!name || seen.has(name)) return;
    seen.add(name);
    options.push({
      id: name,
      name,
      isDefault: isDefault || name === LEG_BASIC_DEFAULT_LAW_NM,
      badge: name === LEG_BASIC_DEFAULT_LAW_NM ? '기본 제공' : null,
      description:
        name === LEG_BASIC_DEFAULT_LAW_NM
          ? '기본 제공되는 산업안전보건법 이행 점검표를 불러옵니다.'
          : '이전에 등록한 법령 점검표를 이어서 작성합니다.',
    });
  };

  // 기본 법령은 항상 최상단
  PushLaw(LEG_BASIC_DEFAULT_LAW_NM, true);

  (lawRows || []).forEach((row) => {
    const name = row?.lawNm ?? row?.LawNm ?? '';
    const defaultYn = row?.defaultYn ?? row?.DefaultYn ?? 'N';
    PushLaw(name, defaultYn === 'Y');
  });

  options.push({ ...LEG_BASIC_LAW_SELECT_NEW_OPTION });
  return options;
};

export const LEG_BASIC_MODAL_APP_TITLE = '안전보건 관계법령 이행 점검';
